
//verifies servicable areas in BLR
export const verifyPincode = (userPin) =>{
    const pins = [560102,560034,560068,560100,560041,560083,560076,562125,560099]
    console.log(userPin);
    if(pins.includes(parseInt(userPin))){
        return true;
    }else return false;
}